import styled from "styled-components";

export const ProgressWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => theme.CONSTANTS.XH * 3}px 0;
`;

export const Line = styled.div`
  position: absolute;
  top: 50%;
  left: 31%;
  right: 31%;
  height: 2px;
  background: ${({ theme }) => theme.THEME.grayText};
  transform: translateY(-50%);
  z-index: 0;

  @media (min-width: 1025px) {
    left: 38%;
    right: 38%;
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.CONSTANTS.XW * 2}px;
  position: relative;
  z-index: 1;
`;

export const Step = styled.div<{ $active: boolean }>`
  width: ${({ theme }) => theme.CONSTANTS.XW * 3}px;
  height: ${({ theme }) => theme.CONSTANTS.XW * 3}px;
  border-radius: 50%;
  background: ${({ $active, theme }) =>
    $active ? theme.THEME.neonBlue : theme.THEME.white};
  transition: background 0.3s ease;

  @media (min-width: 1025px) {
    width: ${({ theme }) => theme.CONSTANTS.XW * 1}px;
    height: ${({ theme }) => theme.CONSTANTS.XW * 1}px;
  }
`;
